// src/api/axios.config.ts
import axios, { AxiosError } from 'axios';
import { authService } from './authService';

// Create an axios instance with default config
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000,
});

// Add request interceptor for auth tokens if needed
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: any) => Promise.reject(error)
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ message?: string }>) => {
    const message =
      error.response?.data?.message ||
      error.message ||
      'Request failed';

    if (error.response?.status === 401) {
      authService.logoutWithReason('Session expired. Please sign in again.');
      return Promise.reject(new Error('Session expired. Please sign in again.'));
    }
    if (error.response?.status === 403 && message === 'No active user found with the given email id.') {
      authService.logoutWithReason(message);
      return Promise.reject(new Error(message));
    }
    const normalizedError = new Error(message);
    // Preserve original error for debugging
    (normalizedError as any).originalError = error;
    return Promise.reject(normalizedError);
  }
);

export default apiClient;
